import React from 'react';

export const HandDrawnCircle = ({ children, className = "" }) => {
  return (
    <span className={`relative inline-block ${className}`}>
      {children}
      <svg
        viewBox="0 0 100 40"
        className="absolute -inset-x-2 -inset-y-1 w-[calc(100%+16px)] h-[calc(100%+8px)] pointer-events-none stroke-emerald-500/60 fill-none"
        preserveAspectRatio="none"
      >
        <path
          d="M5,20 Q10,5 50,5 Q90,5 95,20 Q90,35 50,35 Q10,35 5,20"
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray="300"
          strokeDashoffset="0"
          className="animate-[draw_1.5s_ease-out_forwards]"
        />
      </svg>
    </span>
  );
};
